/**
 * Same as carleadQuestionnaireWithBuyCarQuestionPartialFlow, plus a follow-up
 * BOUGHT_OR_ORDERED_CAR question shown only when BUY_CAR is answered NO.
 */
export const carleadQuestionnaireWithBoughtOrOrderedCarQuestionPartialFlow = {
  SELLPOINT: {
    name: 'SELLPOINT',
    cookieName: 'surveySellpoint',
    next: ['SELL_TYPES', 'email'],
    nodeType: 'questionnaireField',
    inputFieldType: 'select',
    guards: {
      SELL_TYPES: ['SELLPOINT_NOW', 'SELLPOINT_4_WEEKS', 'SELLPOINT_3_MONTHS'],
      email: ['SELLPOINT_NOT_PLANNED']
    }
  },
  SELL_TYPES: {
    name: 'SELL_TYPES',
    cookieName: 'surveySelltypes',
    next: ['BUY_CAR'],
    nodeType: 'questionnaireField',
    inputFieldType: 'select',
    guards: {
      BUY_CAR: ['DEALER', 'PRIVATE']
    }
  },
  BUY_CAR: {
    name: 'BUY_CAR',
    cookieName: 'surveyBuyCar',
    next: ['BOUGHT_OR_ORDERED_CAR', 'email'],
    nodeType: 'questionnaireField',
    inputFieldType: 'select',
    guards: {
      BOUGHT_OR_ORDERED_CAR: ['NO'],
      email: ['YES']
    }
  },
  BOUGHT_OR_ORDERED_CAR: {
    name: 'BOUGHT_OR_ORDERED_CAR',
    cookieName: 'surveyBoughtOrOrderedCar',
    next: ['email'],
    nodeType: 'questionnaireField',
    inputFieldType: 'select',
    guards: {
      email: ['YES', 'NO']
    }
  }
};